module.exports = __webpack_public_path__ + "img/v3.4.f772d7ae.png";